module.exports = __webpack_public_path__ + "img/indoorAlarmAlinoDetect.64564331.webp";